import type { Theme } from '@emotion/react';
import { getScoreColor } from '../../../utils/getScoreColor';

export function getColor(theme: Theme) {
  return ({ value, seriesIndex }: { value: number; seriesIndex: number }) => {
    const isStudentDataBar = seriesIndex === 0;

    if (isStudentDataBar) {
      return getScoreColor(value);
    }

    return theme.tokens.color.specific.reports.semantic['no-data'].value;
  };
}
